import { SeparateWallData } from '../data/separateWall/SeparateWall';
import { EEntityType } from '../types';
import { EEntityStatus2 } from '../types/entity';
import SeparateWallModel2d from './2d/separateWallModel';
import BaseEntity from './BaseEntity';
import { genPolygonHash } from '../utils/hash';

type renderSepWallData = SeparateWallData & { status?: EEntityStatus2; forceUpdate?: boolean };

class SeparateWallEntity extends BaseEntity<EEntityType.SeparateWall> {
  protected override _model2d: SeparateWallModel2d;
  // protected _model3d: SeparateWallModel3d;

  private _separateWallData: renderSepWallData | null = null;
  private _hash: number = 0;

  constructor(params: { id?: string }) {
    super({ type: EEntityType.SeparateWall, id: params.id });

    this._model2d = new SeparateWallModel2d({ id: params.id });
  }

  override set selected(value: boolean) {
    this._selected = value;
    this._model2d.setStatus(value ? EEntityStatus2.Selected : EEntityStatus2.Default);
  }

  override get selected() {
    return this._selected;
  }

  override update(separateWallData: renderSepWallData) {
    let destroyUpdate = !!separateWallData.forceUpdate;
    // let noDestroyUpdate = false;

    const _hash = genPolygonHash(separateWallData.drawSeparateWallInfo.drawShape);
    if (_hash !== this._hash) {
      this._hash = _hash;
      destroyUpdate = true;
    }
    if (separateWallData.type !== this._separateWallData?.type) {
      destroyUpdate = true;
    }
    if (separateWallData.status !== this._separateWallData?.status) {
      destroyUpdate = true;
    }

    if (!destroyUpdate) return;

    this._separateWallData = { ...separateWallData };

    this._model2d.updateSeparateWall(separateWallData);
  }

  // TODO: 待优化
  set2DModelVisible(visible: boolean) {
    this._model2d.setVisible(visible);
  }

  set3DModelVisible(_visible: boolean) {}

  setVisible(visible: boolean) {
    this.set2DModelVisible(visible);
  }

  clear() {
    this._model2d.clear();
  }

  override dispose() {
    super.dispose();
  }
}

export default SeparateWallEntity;
